import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 29 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M17.072 5.121A11.96 11.96 0 0 0 12 4C5.373 4 0 9.373 0 16s5.373 12 12 12 12-5.373 12-12l-6.928-4z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#276FFF",
      "fill-rule": "evenodd",
      d: "M17.072 5.12a12 12 0 0 0-12.01 1.087C.461 9.467-1.15 15.374.832 20.393l5.401-3.385a6.247 6.247 0 0 1 9.069-6.768q.06.03.102.087a.275.275 0 0 1-.102.403l.01-.005.009-.003-4.071 2.883a.664.664 0 0 0-.157.923l2.012 2.837c.21.299.626.369.923.159l4.094-2.903a.265.265 0 0 1 .369.063c.037.052.044.114.05.17v.013a6.254 6.254 0 0 1-9.42 6.227l-4.879 4.061c4.08 3.46 10.131 3.868 14.696.632A11.98 11.98 0 0 0 24 16l-6.927-4z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#00AE0B",
      d: "m24 2 5.196 3v6L24 14l-5.196-3V5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M27.865 6.744c0 .19-.073.382-.217.526l-3.513 3.513a.75.75 0 0 1-.971.07l-.007-.005a1 1 0 0 1-.077-.064l-1.847-1.74a.746.746 0 0 1 .511-1.286c.183 0 .367.067.51.202l1.337 1.26 3.003-3.003a.745.745 0 0 1 1.27.527"
    }, null, -1)
  ])))
}
export default { render: render }